export default {
    data: () => ({
        rowsRequired: {
            0: ['Naam', 'Achternaam', 'GeboorteDatum'],
            1: ['Straatnaam', 'Huisnummer', 'Postcode', 'Woonplaats','Land'],
            2: ['Mobiel nummer', 'E-mailadres', 'E-mailadres verificatie']
        },
        rowsValidated: []
    }),
    methods: {
        checkErrors() {
            if (this.isValidated) {
                let errorFields = _.map(this.errors.items, 'field')
                this.validateRows(errorFields)
            }
        },
        validateRows(errorFields) {
            _.each(this.rowsRequired, function (value, key) {
                Vue.set(this.rowsValidated, key, 'validated');
                _.each(value, function (field) {
                    if (errorFields.indexOf(field) > -1) {
                        Vue.set(this.rowsValidated, key, 'error');
                    }
                }.bind(this))
            }.bind(this))
        }
    }
}